module.exports = __webpack_public_path__ + "static/media/Twin-bell-alarm-clock-ringing-short.bfbf6832.mp3";